@use "../../../globals/bcp-2022/objects/activity-indicator";

$self: ".a-activity-indicator";
$top-box: $self + "__top-box";
$bottom-box: $self + "__bottom-box";

.a-activity-indicator {
  &--large {
    @include activity-indicator.indicator(128px, $top-box, $bottom-box);
  }

  &--small {
    @include activity-indicator.indicator(48px, $top-box, $bottom-box);
  }

  &--default {
    @include activity-indicator.indicator(72px, $top-box, $bottom-box);
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
